import React from 'react';

const Footer: React.FC = () => {
  const navigateTo = (path: string) => {
    const url = path === 'home' ? '/' : `/${path}`;
    window.history.pushState({}, '', url);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <footer className="bg-dark-bg text-gray-300 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 items-start">
          {/* Logo and description */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="/assets/logo.svg" 
                alt="Synergy" 
                className="h-10 w-auto"
              />
            </div>
            {/* <p className="text-sm text-gray-400 leading-relaxed">
              Costruire, insieme. Il nuovo modo di comprare materiali per l'edilizia.
            </p> */}
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Link Rapidi</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => navigateTo('home')}
                  className="hover:text-secondary transition-colors text-left"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigateTo('come-funziona')}
                  className="hover:text-secondary transition-colors text-left"
                >
                  Come funziona
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigateTo('fornitori')}
                  className="hover:text-secondary transition-colors text-left"
                >
                  Fornitori
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigateTo('chi-siamo')}
                  className="hover:text-secondary transition-colors text-left"
                >
                  Chi Siamo
                </button>
              </li>
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contatti</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-secondary flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:info@synergyedilizia.com" className="hover:text-secondary transition-colors">
                  info@synergyedilizia.com
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-secondary flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+393381001285" className="hover:text-secondary transition-colors">
                  +39 338 100 1285
                </a>
              </div>
              
              {/* Social icons placeholder */}
              <div className="pt-4">
                <p className="text-sm text-gray-500 italic">Social media in arrivo</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm text-gray-500">
          <p>&copy; 2025 Synergy. Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
